/* ISSENKA native theme interactions. No GemPages API or runtime is used. */
(function () {
  'use strict';
  var $ = window.jQuery;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function int(value, fallback) { var n = parseInt(value, 10); return Number.isFinite(n) ? n : fallback; }
  function nodes(root, selector) { return Array.from(root.querySelectorAll(selector)); }
  function startCarousel(element, configElement) {
    if (!$ || !$.fn.owlCarousel || element.classList.contains('owl-loaded')) return;
    var d = (configElement || element).dataset;
    var responsive = {};
    [[0, 'xs'], [768, 'sm'], [992, 'md'], [1200, 'lg']].forEach(function (entry) {
      var suffix = entry[1];
      responsive[entry[0]] = {
        items: int(d['col' + suffix], 1),
        nav: d['nav' + suffix] === '1', dots: d['dots' + suffix] === '1',
        margin: int(d['margin' + suffix] || d['m' + suffix] || d.spacing, 0)
      };
    });
    $(element).owlCarousel({
      mouseDrag: false, autoplayHoverPause: d.autoplayhoverpause === '1',
      autoplay: d.autoplay === '1' && !reducedMotion.matches && !window.Shopify?.designMode,
      autoplayTimeout: int(d.autoplaytimeout, 5000), loop: d.loop === '1',
      navSpeed: reducedMotion.matches ? 0 : int(d.navspeed, 300), autoWidth: false,
      responsiveClass: true, responsive: responsive
    });
    nodes(element, '.owl-prev, .owl-next').forEach(function (control) {
      control.setAttribute('aria-label', control.classList.contains('owl-prev') ? '前の画像' : '次の画像');
      control.setAttribute('type', 'button');
    });
  }

  function initAccordions(root) {
    nodes(root, '[data-accordion-group]').forEach(function (group, groupIndex) {
      if (group.dataset.issenkaReady) return;
      group.dataset.issenkaReady = '1';
      var items = Array.from(group.children).filter(function (e) { return e.hasAttribute('data-accordion'); });
      function setOpen(item, open) {
        var control = item.querySelector('[data-control]');
        var content = item.querySelector('[data-content]');
        if (!control || !content) return;
        item.classList.toggle('open', open);
        // The retained accordion stylesheet uses this class for both body
        // visibility and the plus/minus icon, independently of aria-expanded.
        control.classList.toggle('opend', open);
        control.setAttribute('aria-expanded', String(open));
        content.hidden = !open;
        content.style.height = open ? 'auto' : '0px';
        content.style.overflow = open ? 'visible' : 'hidden';
      }
      items.forEach(function (item, index) {
        var control = item.querySelector('[data-control]');
        var content = item.querySelector('[data-content]');
        if (!control || !content) return;
        content.id = (root.id || 'issenka') + '-accordion-' + groupIndex + '-' + index;
        control.setAttribute('role', 'button'); control.tabIndex = 0;
        control.setAttribute('aria-controls', content.id);
        nodes(control, 'button').forEach(function (b) { b.type = 'button'; b.tabIndex = -1; b.setAttribute('aria-hidden', 'true'); });
        setOpen(item, group.dataset.opendefault === '1' && index === int(group.dataset.opentab, 1) - 1);
        function toggle() {
          var open = !item.classList.contains('open');
          if (open && group.dataset.single === '1') items.forEach(function (other) { setOpen(other, false); });
          setOpen(item, open);
        }
        control.addEventListener('click', function (event) { event.preventDefault(); toggle(); });
        control.addEventListener('keydown', function (event) {
          if (event.target === control && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); toggle(); }
        });
      });
    });
  }

  function initProduct(form) {
    if (form.dataset.issenkaReady) return;
    var json = form.querySelector('script.product-json');
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (error) { return; }
    if (!product?.variants?.length) return;
    form.dataset.issenkaReady = '1';
    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;
    var variant = product.variants.find(function (v) { return String(v.id) === variantInput.value; }) || product.variants[0];
    var cartModule = form.querySelector('[data-label="(P) Cart Button"] > .module');
    var button = form.querySelector('[name="add"]');
    var picker;
    if (product.variants.length > 1 && button) {
      picker = document.createElement('select');
      picker.className = 'issenka-variant-picker'; picker.setAttribute('aria-label', '商品オプション');
      product.variants.forEach(function (v) {
        var option = new Option(v.title + (v.available ? '' : '（売り切れ）'), v.id);
        picker.add(option);
      });
      picker.value = String(variant.id);
      cartModule.parentNode.insertBefore(picker, cartModule);
      picker.addEventListener('change', function () {
        variant = product.variants.find(function (v) { return String(v.id) === picker.value; });
        updateVariant(true);
      });
    }
    function updateVariant(updateImage) {
      variantInput.value = String(variant.id);
      if (button) {
        button.disabled = !variant.available;
        button.classList.toggle('disabled', !variant.available);
        var label = button.querySelector('.AddToCartText') || button;
        label.textContent = variant.available ? (cartModule?.dataset.text || 'カートに追加') : (cartModule?.dataset.soldouttext || '売り切れ');
      }
      var priceData = form.querySelector('[id="gf-hidden-variant' + variant.id + '"]');
      nodes(form, '.gf_product-price').forEach(function (e) { if (priceData) e.textContent = priceData.dataset.price; });
      nodes(form, '.gf_product-compare-price').forEach(function (e) {
        if (priceData) e.textContent = priceData.dataset.comparePrice;
        e.style.display = variant.compare_at_price > variant.price ? '' : 'none';
      });
      if (updateImage && variant.featured_image?.src) {
        var featured = form.querySelector('.gf_featured-image');
        if (featured) { featured.src = variant.featured_image.src; featured.dataset.zoom = variant.featured_image.src; }
      }
    }
    updateVariant(false);
    var qty = form.querySelector('[name="quantity"]');
    if (qty) {
      qty.type = 'number'; qty.min = '1'; qty.step = '1'; qty.setAttribute('aria-label', '数量');
      qty.addEventListener('change', function () { qty.value = String(Math.max(1, int(qty.value, 1))); });
      nodes(form, '.gf_product-quantity-minus, .gf_product-quantity-plus').forEach(function (control) {
        control.setAttribute('role', 'button'); control.tabIndex = 0;
        control.setAttribute('aria-label', control.classList.contains('gf_product-quantity-minus') ? '数量を減らす' : '数量を増やす');
        function change(event) {
          event.preventDefault();
          qty.value = String(Math.max(1, int(qty.value, 1) + (control.classList.contains('gf_product-quantity-minus') ? -1 : 1)));
          qty.dispatchEvent(new Event('change', {bubbles: true}));
        }
        control.addEventListener('click', change);
        control.addEventListener('keydown', function (event) { if (event.key === 'Enter' || event.key === ' ') change(event); });
      });
    }
    form.addEventListener('submit', function (event) {
      if (!variant.available) { event.preventDefault(); return; }
      if (qty) qty.value = String(Math.max(1, int(qty.value, 1)));
      // Use Shopify's standard product form, including line-item properties.
      // The native POST performs stock validation and sends the shopper to cart.
    });
    nodes(form, '.gf_product-image-thumb').forEach(function (thumb) {
      var link = thumb.closest('a');
      if (!link) return;
      link.setAttribute('aria-label', thumb.alt + 'の画像を表示');
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var featured = form.querySelector('.gf_featured-image');
        if (featured) { featured.src = thumb.dataset.image || thumb.src; featured.dataset.zoom = thumb.dataset.zoom || featured.src; }
        nodes(form, '.gf_product-image-thumb').forEach(function (t) { t.classList.toggle('active', t === thumb); });
      });
    });
  }

  function initialize(root) {
    nodes(root, '[data-label="Carousel"] > .module').forEach(function (carousel) { startCarousel(carousel); });
    nodes(root, '.gf_product-images-list.owl-carousel').forEach(function (carousel) { startCarousel(carousel, carousel.parentElement); });
    initAccordions(root);
    nodes(root, '.gryffeditor form[action*="/cart/add"]').forEach(initProduct);
    nodes(root, '[data-label="Social Share"] a').forEach(function (link) {
      var url = encodeURIComponent(location.origin + location.pathname);
      var title = encodeURIComponent(document.title);
      if (link.classList.contains('gf_social-facebook')) link.href = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
      if (link.classList.contains('gf_social-twitter')) link.href = 'https://twitter.com/intent/tweet?url=' + url + '&text=' + title;
      if (link.classList.contains('gf_social-email')) link.href = 'mailto:?subject=' + title + '&body=' + url;
      if (!link.href.startsWith('mailto:')) { link.target = '_blank'; link.rel = 'noopener noreferrer'; }
    });
    nodes(root, '[data-label="Youtube"] iframe').forEach(function (frame) { if (!frame.title) frame.title = 'ISSENKA 動画'; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    if ($?.fn.owlCarousel) $(event.target).find('.owl-loaded').trigger('destroy.owl.carousel');
  });
})();
